<template>
  <div class="home">
    <img alt="Vue logo" src="@/assets/pics/landa.png">
   
   
  </div>
    <a href="https://www.instagram.com/truellyblue/" class="btn"  ><i class="fab fa-instagram"></i></a>
    <a href="https://www.facebook.com/profile.php?id=100011389909613" class="btn"  ><i class="fab fa-facebook"></i></a>
      <a href="https://www.youtube.com/channel/UCGK0GgwMcDkWNNb1-4FQoPg/" class="btn"  ><i class="fab fa-youtube"></i></a>
       <a href="https://www.linkedin.com/in/akha-kombora-965959226/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BYhKLhOxQSUG%2FSk87RPnGpw%3D%3D" class="btn"  ><i class="fas fa-envelope-open-text"></i></a>
   
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {
    
  }
}
</script>
